"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/**
 * Icon 需求和设计：https://yuque.antfin-inc.com/eva-engine/specs/sh9uyn
 * 使用 icon font
 */
var g_1 = require("@antv/g");
var Icon = /** @class */ (function (_super) {
    tslib_1.__extends(Icon, _super);
    function Icon(cfg) {
        var _this = _super.call(this, cfg) || this;
        var _a = cfg.position, position = _a === void 0 ? { x: 0, y: 0 } : _a, icon = cfg.icon, _b = cfg.text, text = _b === void 0 ? '' : _b, _c = cfg.spacing, spacing = _c === void 0 ? 8 : _c, iconStyle = cfg.iconStyle, textStyle = cfg.textStyle, _d = cfg.interactive, interactive = _d === void 0 ? false : _d;
        _this.position = position;
        _this.icon = icon;
        _this.text = text;
        _this.spacing = spacing;
        // todo 默认样式
        _this.iconStyle = tslib_1.__assign({ fontFamily: 'iconfont', fontSize: 16, textAlign: 'left', textBaseline: 'top', fill: '#1890ff' }, iconStyle);
        _this.textStyle = tslib_1.__assign({ fontSize: 12, textAlign: 'left', textBaseline: 'middle', fill: '#000' }, textStyle);
        _this.interactive = interactive;
        // 渲染
        _this._initIcon();
        if (_this.interactive) {
            _this._bindEvent();
        }
        return _this;
    }
    // 绘制 icon
    Icon.prototype._initIcon = function () {
        var _a = this.position, x = _a.x, y = _a.y;
        var icon = String.fromCharCode(parseInt(this.icon, 16));
        // icon
        var iconShape = this.addShape('text', {
            attrs: tslib_1.__assign({ x: x,
                y: y, text: icon }, this.iconStyle),
        });
        // text
        if (this.text) {
            var iconBBox = iconShape.getBBox();
            this.addShape('text', {
                attrs: tslib_1.__assign({ x: x + iconBBox.width + this.spacing, y: y + iconBBox.height / 2, text: this.text }, this.textStyle),
            });
        }
        // 背景
        var bbox = this.getBBox();
        this.bg = this.addShape('rect', {
            attrs: {
                x: bbox.x,
                y: bbox.y,
                width: bbox.width,
                height: bbox.height,
                radius: 2,
                fill: '#fff',
            },
            zIndex: -1,
        });
        this.sort();
    };
    /**
     * 绑定事件：
     * 1. hover 加背景
     * 2. 点击 emit 出去
     * @private
     */
    Icon.prototype._bindEvent = function () {
        var _this = this;
        this.on('mouseover', function () {
            _this.bg.attr('fill', '#F5F5F5');
            _this.get('canvas').draw();
        });
        this.on('mouseout', function () {
            _this.bg.attr('fill', '#fff');
            _this.get('canvas').draw();
        });
    };
    return Icon;
}(g_1.Group));
exports.default = Icon;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/gui/lib/icon/index.js
// module id = 1047
// module chunks = 37